import { CommentData } from 'redux/ATS/comments/types'
import { PaginationTypes } from 'types/sharedResponse'

export const GET_CANDIDATES = 'GET_CANDIDATES'
export const GET_CANDIDATES_PENDING = 'GET_CANDIDATES_PENDING'
export const GET_CANDIDATES_FULFILLED = 'GET_CANDIDATES_FULFILLED'
export const GET_CANDIDATES_REJECTED = 'GET_CANDIDATES_REJECTED'

export const SYNC_ATS_CANDIDATE = 'SYNC_ATS_CANDIDATE'
export const SYNC_ATS_CANDIDATE_PENDING = 'SYNC_ATS_CANDIDATE_PENDING'
export const SYNC_ATS_CANDIDATE_FULFILLED = 'SYNC_ATS_CANDIDATE_FULFILLED'
export const SYNC_ATS_CANDIDATE_REJECTED = 'SYNC_ATS_CANDIDATE_REJECTED'

type CandidateJobData = {
  id: number
  title_ar: string
  title_en: string
  title_i18n: string
}

type CandidateStageData = {
  id: number
  stage_name: string
  stage_name_i18n: string
}

export type CandidateJobApplicationData = {
  id: number
  job: CandidateJobData
  job_workflow_stage: CandidateStageData
}

export type Candidate = {
  email?: string
  created_at: string
  id: number
  job_application: CandidateJobApplicationData
  name_ar: string
  links?: string[]
  comments?: CommentData[]
  nationality_id?: number
  organization_id?: number
  name_en: string
  name_i18n: string
  updated_at: string
  phone_number: string
  address: string
  is_hiring_manager?: boolean
  is_recruiter?: boolean
  current_role: string
  country_id: number
  city: {
    id: number
    name: string
  }
  cv_file_fields?: {
    name?: string
    url?: string
    size?: string
  }
  country_phone_code?: string
}

export type GetAllCandidatesData = {
  candidates: Candidate[]
  total_candidates: number
  ids: number[]
  skip_onboarding?: boolean
}

export type GetAllCandidatesResponse = {
  data: GetAllCandidatesData
  pagination?: PaginationTypes
  success: boolean
  statusCode: number
}

export type GetAllCandidatesRequestFilter = {
  country_id: number[]
  assigned_job: number[]
  nationality_id: number[]
  status?: string
  search: string
}

export type GetAllCandidatesRequest = {
  filter?: GetAllCandidatesRequestFilter
  sort?: {
    [key: string]: string
  }
  page?: number
  per_page?: number
}
